import TemplateNodePositionedItem from './TemplateNodePositionedItem';
import { useContext } from 'react';
import { NodeDisplayContext } from './Contexts';

export default function MicroscopyRegionItemLayer(props){

  let {
    children,
    nodes,
    regions,
    selectedNodes,
    onEvent,
    parentBox,
    parentPixelDimensions,

  } = props;


  let nodeDisplayContext = useContext(NodeDisplayContext);



  return <div class="absolute-cover" style={{
    pointerEvents:'none',
    zIndex:101,
  }}>
    {children.map(cId => {



      let childNode = nodes[cId];

      let childDisplayOverride = nodeDisplayContext?.nodeDisplay?.({node:childNode})

      if( childDisplayOverride !== undefined ){
        return childDisplayOverride;
      }

      return childNode.type !== "regionOutline" && (
        <>
          <TemplateNodePositionedItem key={cId} {...{
            selectedNodes,
            onEvent,
            evaluate:true,
            nodeId:cId,
            node:childNode,
            parentBox,
            parentPixelDimensions,
            nodes,
            regions,
          }}/>
        </>
      )
    })}
  </div>
}
